let debugLog;

export const initializeLogger = () => {
  debugLog = window.debug('Payments');
};

/**
 * `localStorage` is not available for webviews in native apps, so as a workaround
 * `window.DEBUG_PAYMENTS` can be set to a truthy value in the console to send the
 * messages to the console instead of just using the more enhanced debug logger.
 */
const log = (category) => (message, args) => {
  const prefix = category ? `${category} - ` : '';
  debugLog(`${prefix}${message}`, args);

  if (window.DEBUG_PAYMENTS) {
    // eslint-disable-next-line no-console
    console.log(`PAYMENTS - ${prefix}${message}`, args);
  }
};

export default log;
